import type {
  ComponentValueResponse,
  PortfolioSustainabilityStateResponse,
  SaveComponentValueResponse,
  SaveSustainabilityDecisionRequest,
  SaveSustainabilityDecisionResponse,
  SustainabilityComponentInput,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(`${BASE}/${instanceId}/sustainability/flow-instance-value`);
}

export function saveFlowInstanceValue(instanceId: string, input: SustainabilityComponentInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/sustainability/flow-instance-value`,
    input satisfies SustainabilityComponentInput,
  );
}

export function getPortfolioSustainabilityState(instanceId: string, portfolioId: string) {
  return get<PortfolioSustainabilityStateResponse>(
    `${BASE}/${instanceId}/portfolios/${portfolioId}/sustainability-state`,
  );
}

export function savePortfolioSustainabilityDecision(
  instanceId: string,
  portfolioId: string,
  request: SaveSustainabilityDecisionRequest,
) {
  return post<SaveSustainabilityDecisionResponse>(
    `${BASE}/${instanceId}/portfolios/${portfolioId}/sustainability-decision`,
    request satisfies SaveSustainabilityDecisionRequest,
  );
}
